/* Built In Imports */

/* External Imports */
import {
  Box,
  Flex,
  Heading,
  Link,
  List,
  ListItem,
  Text,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@eternal/Components/Ui/LazyLoadImageComponent';
import StructuredTextParser from '@eternal/Components/Utility/StructuredTextParser';
import { refineUrlDomain } from '@eternal/Components/Utility/utils';
/* Services */

/**
 *
 * @param {Object} footerData
 * @returns
 */
const Footer = ({ footerData }) => {
  // console.log(footerData, 'footerData footer');
  const data = footerData.allIsoMainMenus[0];
  const submenuItems = data.submenuItems;
  // console.log(data);
  return (
    <Box
      as="footer"
      w="100%"
      bg="#010101"
      pr={{ base: '20px', lg: '60px', xl: '0' }}
      pl={{ base: '16px', lg: '60px', xl: '0' }}
    >
      <Box maxW={1200} w={{ base: '100%', lg: '90%' }} mx="auto" py="50px">
        <Flex
          justifyContent="space-between"
          maxW={{ base: 234, sm: 1200 }}
          w="100%"
          mx={{ base: 0, md: 'auto' }}
          gap="1.5rem"
          flexDir={{ base: 'column', md: 'row' }}
        >
          <Flex
            flexDir="column"
            justifyContent="space-between"
            maxW={260}
            w="auto"
            alignItems="flex-start"
            alignSelf="stretch"
          >
            <Heading as="h3" color="#F8FBFF" fontSize="22px">
              {data?.title}
            </Heading>
            <Box display={{ base: 'none', xl: 'block' }}>
              <Text
                color="#C9BAAB"
                fontSize="14px"
                fontFamily="FedraSansStd-book"
              >
                <Link
                  href={refineUrlDomain(submenuItems[4].url)}
                  textDecoration={'underline'}
                  mr="5px"
                >
                  {submenuItems[4].title}
                </Link>
                |
                <Link
                  href={refineUrlDomain(submenuItems[5].url)}
                  textDecoration={'underline'}
                  ml="5px"
                >
                  {submenuItems[5].title}
                </Link>
              </Text>
              <Text fontFamily="FedraSansStd-book">
                <Link
                  href={refineUrlDomain(submenuItems[6].url)}
                  color="#fff"
                  fontSize="12px"
                >
                  {submenuItems[6].title}
                </Link>
              </Text>
            </Box>
          </Flex>
          <List listStyleType="none" display={{ base: 'none', md: 'block' }}>
            <Heading as="h5" color="#F8FBFF" fontSize="1rem">
              <Link
                href={refineUrlDomain(submenuItems[0].url)}
                _hover={{
                  textDecoration: 'none',
                }}
              >
                {submenuItems[0]?.title}
              </Link>
            </Heading>
            <Box mt="15px">
              {submenuItems[0].submenuItems.map(menu => (
                <ListItem
                  color="#C9BAAB"
                  fontSize="1rem"
                  lineHeight="2rem"
                  fontFamily="FedraSansStd-book"
                >
                  <Link href={refineUrlDomain(menu.url)}>{menu?.title}</Link>
                </ListItem>
              ))}
            </Box>
          </List>
          <Flex
            flexDir="column"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Box>
              <Heading as="h5" color="#F8FBFF" fontSize="1rem">
                <Link
                  href={refineUrlDomain(submenuItems[1].url)}
                  _hover={{
                    textDecoration: 'none',
                  }}
                >
                  {submenuItems[1]?.title}
                </Link>
              </Heading>
              <List
                listStyleType="none"
                display="flex"
                gap={2}
                flexWrap="wrap"
                mt="12px"
                w={{ base: '218px', md: '175px', xl: 'auto' }}
              >
                {submenuItems[1].submenuItems.map(menu => (
                  <ListItem
                    color="#C9BAAB"
                    fontSize="1rem"
                    lineHeight="2rem"
                    p="0 3px"
                    display="flex"
                  >
                    <Link href={refineUrlDomain(menu.url)} display="flex">
                      <LazyLoadImageComponent
                        src={menu?.icon?.url}
                        maxW={35}
                        maxH={35}
                        w={30}
                        height={30}
                        verticalAlign="middle"
                        alt={menu.title}
                        objectFit="contain"
                        objectPosition="center"
                        display="flex"
                        alignSelf="center"
                      />
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Box>

            <Heading as="h5" color="#F8FBFF" fontSize="1rem" mt="2.5rem">
              <Link
                href={refineUrlDomain(submenuItems[1].url)}
                _hover={{
                  textDecoration: 'none',
                }}
              >
                {submenuItems[2]?.title}
              </Link>
              <List
                listStyleType="none"
                display="flex"
                gap={4}
                flexWrap="wrap"
                mt="10px"
              >
                {submenuItems[2].submenuItems.map(menu => (
                  <ListItem color="#C9BAAB" fontSize="1rem" lineHeight="2rem">
                    <Link href={refineUrlDomain(menu.url)}>
                      <LazyLoadImageComponent
                        src={menu?.icon?.url}
                        verticalAlign="middle"
                        alt={menu.title}
                      />
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Heading>
          </Flex>
          <List listStyleType="none" display={{ base: 'block', md: 'none' }}>
            <Heading as="h5" color="#F8FBFF" fontSize="1rem">
              <Link
                href={refineUrlDomain(submenuItems[0].url)}
                _hover={{
                  textDecoration: 'none',
                }}
              >
                {submenuItems[0]?.title}
              </Link>
            </Heading>
            <Box mt="15px">
              {submenuItems[0].submenuItems.map(menu => (
                <ListItem
                  color="#C9BAAB"
                  fontSize="1rem"
                  lineHeight="2rem"
                  fontFamily="FedraSansStd-book"
                >
                  <Link href={refineUrlDomain(menu.url)}>{menu?.title}</Link>
                </ListItem>
              ))}
            </Box>
          </List>
          <Box>
            <Heading as="h5" color="#F8FBFF" fontSize="1rem">
              <Link
                href={refineUrlDomain(submenuItems[3].url)}
                _hover={{
                  textDecoration: 'none',
                }}
              >
                {submenuItems[3]?.title}
              </Link>
            </Heading>
            <StructuredTextParser
              color="#C9BAAB"
              fontSize="16px"
              fontFamily="FedraSansStd-book"
              str={render(submenuItems[3].body)}
              sx={{
                a: {
                  color: '#C9BAAB',
                },
                'a:hover': {
                  textDecoration: 'underline',
                },
              }}
            />
          </Box>
        </Flex>

        <Box
          display={{ base: 'block', xl: 'none' }}
          mt={{ base: '1.8rem', md: '3.2rem' }}
        >
          <Text
            color="#C9BAAB"
            fontSize="14px"
            textAlign={{ base: 'left', md: 'center' }}
            fontFamily="FedraSansStd-book"
          >
            <Link
              href={refineUrlDomain(submenuItems[4].url)}
              textDecoration={'underline'}
              mr="5px"
            >
              {submenuItems[4].title}
            </Link>{' '}
            |
            <Link
              href={refineUrlDomain(submenuItems[5].url)}
              textDecoration={'underline'}
              ml="5px"
            >
              {' '}
              {submenuItems[5].title}
            </Link>
          </Text>
          <Text
            textAlign={{ base: 'left', md: 'center' }}
            fontFamily="FedraSansStd-book"
          >
            <Link
              href={refineUrlDomain(submenuItems[6].url)}
              color="#fff"
              fontSize="12px"
            >
              {submenuItems[6].title}
            </Link>
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
